import dayjs from "dayjs"


export const clearFilterData = {
  AptTmSt: null,
  AptTmEn: null,
  JobNo: null,
  Bkg: null,
  ContNo: null,
  InvNo: null,
  InvDteSt: null,
  InvDteEn: null,
  XpssDocDteSt: null,
  XpssDocDteEn: null,
  JobOrdId: null,
  JobId: null,
  CusId: null,
  PaySts: null,
  RVNo: null,
  PVNo: null,
  RcptNo: null,
  JobTags: [],
}

export const initFilterData = {
  ...clearFilterData,
  InvDteSt: dayjs().startOf('month').format('YYYY-MM-DD 00:00:00'),
  InvDteEn: dayjs().endOf('month').format('YYYY-MM-DD 23:59:59'),
}